import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  StripeConfigurationControl,
  StripeConfigurationFormValues,
} from '../../StripeConfigurationFormSchema';
import { SYNC_CUSTOMERS_OPTIONS } from './constants';

type CustomerConfigurationSectionProps = {
  defaultValues: StripeConfigurationFormValues;
  control: StripeConfigurationControl;
};

export const CustomerConfigurationSection: FC<CustomerConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Customers" iconName="Customers">
    <Controller
      name="syncCustomer"
      control={control}
      defaultValue={defaultValues.syncCustomer}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to sync your customer list"
          options={SYNC_CUSTOMERS_OPTIONS}
          value={value}
          keyExtractor={(option) => option.value}
          onChange={onChange}
        />
      )}
    />
  </ConfigurationSection>
);
